export default __webpack_public_path__ + "static/media/english-to-chinese-screenshot-06.04dca30d.png";